export default __webpack_public_path__ + "static/media/arrow-new-right.70668d2f.svg";